export default __webpack_public_path__ + "static/remote-patient-monitoring-solutions-company-peerbits-99bd4830acec1723b00d92fbeffa4978.png";